import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrganization = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2698_2345)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4 11.67V7.5H12V11.67",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 7V4",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 4.5C8.82843 4.5 9.5 3.82843 9.5 3C9.5 2.17157 8.82843 1.5 8 1.5C7.17157 1.5 6.5 2.17157 6.5 3C6.5 3.82843 7.17157 4.5 8 4.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 14.5C4.82843 14.5 5.5 13.8284 5.5 13C5.5 12.1716 4.82843 11.5 4 11.5C3.17157 11.5 2.5 12.1716 2.5 13C2.5 13.8284 3.17157 14.5 4 14.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 14.5C12.8284 14.5 13.5 13.8284 13.5 13C13.5 12.1716 12.8284 11.5 12 11.5C11.1716 11.5 10.5 12.1716 10.5 13C10.5 13.8284 11.1716 14.5 12 14.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2698_2345",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgOrganization;
